import React, { FunctionComponent } from "react";
import { ReactElement, Suspense } from "react";
import { Outlet, useLocation, useRoutes } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { theme } from "@/theme";
import FormA from "@/pages/FormA";
import MainLayout from "@/layouts/MainLayout";
import FormB from "@/pages/FormB";
import FormC from "@/pages/FormC";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import Download from "./Download";
import Login from "@/pages/Login";
import ForgetPwd from "@/pages/ForgetPwd";
import ResetPwd from "./ResetPwd";
import { Helmet } from "react-helmet";

const BasicComponent: FunctionComponent<{ isNeedLayout?: boolean }> = ({
  isNeedLayout = true,
}) => {
  const { pathname } = useLocation();
  const isForm = pathname.includes("form");
  const titleName = isForm
    ? "スマートリンクタウン いわき中央台 スマートエネルギーサービス申込み入力フォーム"
    : "スマートリンクタウン いわき中央台 スマートエネルギーサービス会員情報管理ポータル";

  return (
    <Suspense>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Helmet>
            <title>{titleName}</title>
          </Helmet>
          {/*{props.children}*/}
          {isNeedLayout ? (
            <MainLayout>
              <Outlet />
            </MainLayout>
          ) : (
            <Outlet />
          )}
        </LocalizationProvider>
      </ThemeProvider>
    </Suspense>
  );
};

export function App(): ReactElement | null {
  return useRoutes([
    {
      path: "/form",
      element: <BasicComponent />,
      children: [
        {
          path: "a",
          element: <FormA />,
        },
        {
          path: "b",
          element: <FormB />,
        },
        {
          path: "c",
          element: <FormC />,
        },
      ],
    },
    {
      path: "/download",
      element: <BasicComponent />,
      children: [
        {
          path: "",
          element: <Download />,
        },
      ],
    },
    {
      path: "/login",
      element: <BasicComponent isNeedLayout={false} />,
      children: [
        {
          path: "",
          element: <Login />,
        },
      ],
    },
    {
      path: "/forget-password",
      element: <BasicComponent isNeedLayout={false} />,
      children: [
        {
          path: "",
          element: <ForgetPwd />,
        },
      ],
    },
    {
      path: "/reset-password",
      element: <BasicComponent isNeedLayout={false} />,
      children: [
        {
          path: "",
          element: <ResetPwd />,
        },
      ],
    },
    {
      path: "/reset-password/:token",
      element: <BasicComponent isNeedLayout={false} />,
      children: [
        {
          path: "",
          element: <ResetPwd />,
        },
      ],
    },

    {
      path: "*",
      element: <></>,
    },
  ]);
}
